import { areDatesNotEqual, areNotEqual, isDateEmpty, isDropdownEmpty, isNumberEmpty, isStringEmpty, isYnDropdownEmpty } from "@/common/validation-checkers";
import ITrip from "@/models/trips/itrip";

export function TripHasRequiredFormFields(trip: ITrip) {
    
    if (!trip) {
        return false;
    }
    
    if (
        !isDateEmpty(trip.reservationDate) &&
        !isDropdownEmpty(trip.bookedRoomTypeId)
    ) {
        return true;
    }

    return false;
}

export function TripHasFormData(trip: ITrip) {

    if (!trip) {
        return false;
    }

    if (
        isNumberEmpty(trip.fullPrice) &&
        isNumberEmpty(trip.discount) &&
        isDateEmpty(trip.reservationDate) &&
        isDropdownEmpty(trip.bookedRoomTypeId) &&
        isDropdownEmpty(trip.bookedViaId) &&
        isYnDropdownEmpty(trip.isCancelled) &&
        isStringEmpty(trip.staffNotes) &&
        isStringEmpty(trip.guestNotes)
    ) {
        return false;
    }

    return true;
}

export function TripHasChanged(original: ITrip, revised: ITrip) {

    if (!original || !revised) {
        return false;
    }

    if (
        areNotEqual(original.fullPrice, revised.fullPrice) ||
        areNotEqual(original.discount, revised.discount) ||
        areNotEqual(original.bookedRoomTypeId, revised.bookedRoomTypeId) ||
        areNotEqual(original.bookedViaId, revised.bookedViaId) ||
        areNotEqual(original.isCancelled, revised.isCancelled) ||
        areNotEqual(original.staffNotes, revised.staffNotes) ||
        areNotEqual(original.guestNotes, revised.guestNotes) ||
        areDatesNotEqual(original.reservationDate, revised.reservationDate)
    ) {
        return true;
    }
    else {
        return false;
    }
}